import axios from 'axios';
import { getSession } from 'next-auth/react';
import { envVariables } from '../utils';

const axiosInstance = axios.create({
  baseURL: envVariables.APIURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const session = await getSession();
    const tokenValue = session?.accessToken;
    if (tokenValue) config.headers.Authorization = `Bearer ${tokenValue}`;
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  },
);

export default axiosInstance;
